import { CardHistoricoProps } from "../../Base/types";
import CardHistoricoBase from "../../Base/CardHistoricoBase";
import { Play, LucideIcon } from "lucide-react";
import ExpandedContent from "./ExpandedContent";

const detectaDemandaIniciada = (acao: string): boolean => {
    const acaoLower = acao.toLowerCase().trim();
    return acaoLower.includes('demanda iniciada') || 
           acaoLower.includes('iniciou demanda') ||
           acaoLower.includes('iniciar demanda');
};

const getIconDemandaIniciada = (acao: string): { Icon: LucideIcon; color: string } => {
    return { Icon: Play, color: 'var(--c10b981)' };
};

export default function CardDemandaIniciada({ 
    item, 
    onNavigateToFile, 
    isExpanded, 
    onToggleExpand 
}: CardHistoricoProps) {
    return (
        <CardHistoricoBase
            item={item}
            icon={getIconDemandaIniciada(item.acao)}
            temExpansaoDisponivel={true}
            isExpanded={isExpanded}
            onToggleExpand={onToggleExpand}
            expandedContent={
                <ExpandedContent item={item} onNavigateToFile={onNavigateToFile} />
            }
        />
    );
}

export const demandaIniciadaConfig = {
    tipo: 'demanda_iniciada',
    detectaTipo: detectaDemandaIniciada,
    getIcon: getIconDemandaIniciada,
    temExpansao: () => true,
    Component: CardDemandaIniciada
};

